// Слайдеры туров и экскурсий: бесконечная лента, стрелки прокручивают на одну карточку.
// Бесконечность сделана копиями: слева и справа от слайдов лежит по их копии, и когда
// прокрутка уходит в копию, позиция незаметно переносится на такой же слайд в оригинале.
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.tours-slider').forEach(initToursSlider);
});

function initToursSlider(slider) {
    const track = slider.querySelector('.tours-slider-track');
    const prevBtn = slider.querySelector('.tours-slider-prev');
    const nextBtn = slider.querySelector('.tours-slider-next');
    if (!track || !prevBtn || !nextBtn) return;

    const originals = Array.from(track.querySelectorAll('.tours-slide'));
    const count = originals.length;

    function step() {
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return originals[0].getBoundingClientRect().width + gap;
    }

    function jumpTo(left) {
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = left;
        track.style.scrollBehavior = '';
    }

    // Все туры помещаются на экран — листать нечего
    if (count === 0 || track.scrollWidth <= track.clientWidth + 1) {
        slider.classList.add('is-static');
        return;
    }

    function makeClone(slide) {
        const clone = slide.cloneNode(true);
        clone.classList.add('is-clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach(function(link) {
            link.setAttribute('tabindex', '-1');
        });
        return clone;
    }

    const before = document.createDocumentFragment();
    const after = document.createDocumentFragment();
    originals.forEach(function(slide) {
        before.appendChild(makeClone(slide));
        after.appendChild(makeClone(slide));
    });
    track.insertBefore(before, track.firstChild);
    track.appendChild(after);

    // Индекс среди всех слайдов, включая копии: оригиналы занимают [count, 2 * count)
    let index = count;
    // true, пока лента едет к слайду index после нажатия стрелки
    let animating = false;
    jumpTo(index * step());

    // Если прокрутка ушла в копии, сдвигает её ровно на длину набора слайдов.
    // Картинка на экране при этом не меняется, поэтому сдвиг можно делать и посреди движения.
    function wrap() {
        const s = step();
        const pos = track.scrollLeft;
        let shift = 0;
        if (pos < count * s - s / 2) shift = count;
        else if (pos >= 2 * count * s - s / 2) shift = -count;
        if (shift) {
            jumpTo(pos + shift * s);
            index += shift;
        }
        return shift !== 0;
    }

    function settle() {
        const s = step();
        if (animating && Math.abs(track.scrollLeft - index * s) > 2) {
            // Сдвиг обрывает плавную прокрутку — докатываем до нужного слайда
            if (wrap()) track.scrollTo({ left: index * step(), behavior: 'smooth' });
            return;
        }
        animating = false;
        // Пользователь мог пролистать ленту пальцем или колесом
        index = Math.round(track.scrollLeft / s);
        wrap();
    }

    let settleTimer = null;
    track.addEventListener('scroll', function() {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(settle, 150);
    }, { passive: true });

    function move(direction) {
        wrap();
        index += direction;
        animating = true;
        track.scrollTo({ left: index * step(), behavior: 'smooth' });
    }

    prevBtn.addEventListener('click', function() { move(-1); });
    nextBtn.addEventListener('click', function() { move(1); });

    // Пользователь взял ленту сам — перестаём докатывать её к слайду
    ['touchstart', 'pointerdown', 'wheel'].forEach(function(name) {
        track.addEventListener(name, function() { animating = false; }, { passive: true });
    });

    // Ширина карточки зависит от ширины окна — возвращаемся на тот же слайд
    window.addEventListener('resize', function() {
        jumpTo(index * step());
    });
}
